module.exports = __webpack_public_path__ + "static/img/13.5d77be5c.png";